import React from 'react'
import {isCheckIn, isCheckOut} from '../../utils/meeting'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../context/LocaleContext'
import {
  combineDateAndTimeStrings,
  formatTimeWithMeridiem
} from '../../utils/time'

const MeetingRoomSchedule = ({
  reservations,
  onCheckIn,
  onCheckOut,
  onViewMeetingDetails,
  isLoading,
  isCheckingIn
}) => {
  const localeState = useLocaleState()
  const reservationItems = reservations.map(reservation => {
    const now = new Date().getTime()

    const {
      reserveDateStart,
      reserveDateEnd,
      reserveTimeStart,
      reserveTimeEnd,
      reserveResId,
      reserveReservationName,
      reserveMeetingPrivate
    } = reservation

    let meetingStart = combineDateAndTimeStrings(
      reserveDateStart,
      reserveTimeStart
    )
    let meetingEnd = combineDateAndTimeStrings(reserveDateEnd, reserveTimeEnd)

    const isCheckedIn = reservation.verified === 1

    const checkInEnabled =
      isCheckIn({isCheckedIn, meetingStart, meetingEnd}) &&
      !isLoading &&
      !isCheckingIn
    const checkOutEnabled =
      isCheckOut({isCheckedIn, meetingStart, meetingEnd}) &&
      !isLoading &&
      !isCheckingIn

    const formattedTimeStart = formatTimeWithMeridiem({date: meetingStart})
    const formattedTimeEnd = formatTimeWithMeridiem({date: meetingEnd})

    const {time: timeStart, ampm: ampmStart} = formattedTimeStart
    const {time: timeEnd, ampm: ampmEnd} = formattedTimeEnd

    const isCurrentTime =
      now >= meetingStart.getTime() && now <= meetingEnd.getTime()

    const hasButton = checkInEnabled || checkOutEnabled

    const checkIn = () => onCheckIn(reservation)

    const checkOut = () => onCheckOut(reservation)

    const viewMeetingDetails = () => onViewMeetingDetails(reservation)

    return (
      <ReservationItemContainer key={reserveResId}>
        <ReservationItem
          isCurrentTime={isCurrentTime}
          hasButton={hasButton}
        >
          <ReservationTimeRange>
            <ReservationTime>{timeStart}</ReservationTime>
            <ReservationTimeAmPm>{ampmStart}</ReservationTimeAmPm>
            <ReservationTime>-</ReservationTime>
            <ReservationTime>{timeEnd}</ReservationTime>
            <ReservationTimeAmPm>{ampmEnd}</ReservationTimeAmPm>
          </ReservationTimeRange>
          <ReservationName>
            {reserveMeetingPrivate === 0
              ? reserveReservationName
              : _L({key: 'Private Meeting', localeState})}
          </ReservationName>
        </ReservationItem>
        {checkInEnabled && (
          <CheckIn onClick={checkIn}>
            {_L({key: 'Check In', localeState})}
          </CheckIn>
        )}
        {checkOutEnabled && (
          <CheckOut onClick={checkOut}>
            {_L({key: 'Check Out', localeState})}
          </CheckOut>
        )}
      </ReservationItemContainer>
    )
  })

  return <Container>{reservationItems}</Container>
}

export default MeetingRoomSchedule

const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  box-sizing: border-box;
`

const ReservationItemContainer = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (max-device-width: 708px) {
    flex-direction: column;
    align-items: center;
  }
`

const ReservationTime = styled.div`
  float: left;
  font-size: 22px;
  padding-right: 4px;
  
  @media only screen and (max-device-width: 708px) {
    font-size: 14px;
  }
`

const ReservationTimeAmPm = styled.div`
  float: left;
  font-size: 14px;
  padding-right: 4px;
  padding-top: 3px;
  
  @media only screen and (max-device-width: 708px) {
    font-size: 12px;
    padding-top: 2px;
  }
`

const ReservationName = styled.div`
  height: 100%;
  padding-top: 3px;
  
  @media only screen and (max-device-width: 708px) {
    font-size: 14px;
    padding-left: 20px;
  }
`

const CheckIn = styled.div`
  width: 112px;
  height: 68px;
  margin-left: 12px;
  margin-bottom: 12px;
  border-radius: 4px;
  background-color: #3395fe;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media only screen and (max-device-width: 708px) {
  	font-size: 14px;
  	width: 288px;
  	height: 48px;
  	margin-left: 0;
  }
`

const CheckOut = styled(CheckIn)`
  background-color: #5a6480;
`
const ReservationItem = styled.div`
  width: ${props => (props.hasButton ? '584' : '708')}px;
  height: 68px;
  margin-bottom: 12px;
  border-radius: 4px;
  background-color: #5c6174;
  color: white;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: 250px 1fr;
  grid-template-rows: auto;
  align-content: center;
  border-left: ${props => (props.isCurrentTime ? '6px solid #3395fe' : 'none')};

  @media only screen and (max-device-width: 708px) {
    width: 288px;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`

const ReservationTimeRange = styled.div`
  height: 100%;
  padding-left: 24px;
  
  @media only screen and (max-device-width: 708px) {
  	padding-left: 20px;
  }
`
